import { Button, Dialog, DialogPanel } from "@headlessui/react";
import { useState, useEffect } from "react";
import TextF from "../../assets/campanas/icono crear.svg";
import useAutomatizaciones from "../../hooks/useAutomatizaciones";
import clsx from "clsx";

export default function CrearCamp({
  isOpen,
  onClose,
  onSuccess,
  tareaInicial,
}) {
  const [descripcion, setDescripcion] = useState(tareaInicial || "");
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  const { crearAutomatizacion, loading } = useAutomatizaciones();

  useEffect(() => {
    if (tareaInicial) {
      setDescripcion(tareaInicial);
    }
  }, [tareaInicial]);

  // Limpiar al cerrar
  useEffect(() => {
    if (!isOpen) {
      setTitle("");
      setDescripcion("");
      setError("");
    }
  }, [isOpen]);

  const handleCrear = async () => {
    if (!title.trim()) {
      setError("El nombre de la automatización es requerido.");
      return;
    }
    setError("");

    try {
      const nuevaAutomatizacion = await crearAutomatizacion({
        nombre: title.trim(),
        descripcion: descripcion.trim() || undefined,
      });

      onSuccess(nuevaAutomatizacion);
      onClose();
    } catch (error) {
      setError(error.message || "Error al crear la automatización");
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-casal/20 backdrop-blur-sm" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-2xl bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-2xl border-2 border-Acapulco max-h-[90vh] overflow-y-auto">
          <div className="flex-col md:flex-row flex">
            <div className="bg-casal md:min-h-full rounded-t-2xl md:rounded-tr-none md:rounded-l-2xl w-full md:w-32 flex-shrink-0">
              <img src={TextF} alt="Crear Automatización" className="p-6 mx-auto w-36 md:w-72" />
            </div>
            <div className="p-6 w-full">
              <div>
                <p className="text-2xl text-casal font-semibold">Crear Automatización</p>
              </div>

              {/* Nombre */}
              <div className="mt-4">
                <label className="block mb-2 text-sm font-bold text-Acapulco dark:text-gray-300">
                  Nombre de la automatización <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => { setTitle(e.target.value); setError(""); }}
                  onKeyDown={(e) => e.key === "Enter" && handleCrear()}
                  className="w-full p-2 text-gray-600 dark:text-gray-300 placeholder-gray-400 outline-1 border rounded-xl bg-transparent"
                  placeholder="Ej: Recordatorio de pago 3 días antes"
                  autoFocus
                />
                {error && (
                  <p className="text-red-500 text-xs mt-1">{error}</p>
                )}
              </div>

              {/* Descripción */}
              <div className="mt-4">
                <label className="block mb-2 text-sm font-bold text-Acapulco dark:text-gray-300">
                  Descripción <span className="font-medium text-xs">(Opcional)</span>
                </label>
                <textarea
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  className="w-full h-20 p-3 text-gray-600 dark:text-gray-300 placeholder-gray-400 outline-1 border rounded-xl resize-none bg-transparent"
                  placeholder="Describe brevemente el objetivo de esta automatización"
                />
              </div>

              <p className="mt-3 text-xs text-gray-400 dark:text-gray-500">
                Configurarás el disparador, filtros y acciones en el siguiente paso.
              </p>

              {/* Botones */}
              <div className="flex justify-end gap-3 mt-6">
                <Button
                  onClick={onClose}
                  className="px-6 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors"
                  disabled={loading}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={handleCrear}
                  className={clsx(
                    "bg-casal text-lg font-semibold hover:bg-casal/90 text-white px-8 py-2 rounded-full transition-colors",
                    loading && "opacity-50 cursor-not-allowed"
                  )}
                  disabled={loading}
                >
                  {loading ? "Creando..." : "Crear"}
                </Button>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
